import { decode } from "html-entities";
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { getCurrencySign, isInPhoneScreen } from "../../utils/utils";
import { withAuth } from "../AuthContext";
import Button from "../Utils/Button";
import Error from "../Utils/Error";
import Paypal from "./Paypal";
import { gaEvents } from "../../analytics/events";

class ChooseMembershipFeeGift extends Component {
    constructor(props) {
        super(props);
        const u = this.props.auth.user;
        this.state = {
            defaultMembershipFee: "50",
            savedMembershipFee: u.membershipFee,
            membershipFee: 50,
            membershipFeeStatus: null,
            currencySign: null,
            loading: false,
            error: "",
            checkout: false,
        };
    }

    componentDidMount() {
        console.log("component did mount!");
        this.props.auth.refreshUser();
        const currencySign = this.props.location.state !== undefined ? this.props.location.state.currencySign : this.props.auth.user.currencyValue;
        const getCurrency = async () => {
            const data = await getCurrencySign(
                currencySign
            );
            this.setState({
                currencySign: data.sign,
            });
        };
        getCurrency();
    }

    handleChoosePaypal() {
        gaEvents.eventGeneric(
            "button_click",
            "paypal-chosen",
            this.props.auth.user.id +
                "(GIFT) - choose membership fee - button - choose Paypal"
        );
        this.setState({ membershipFeeStatus: "pending" }, () => {
            this.props.auth.updateUser(this.state).then(() => {
                this.setState({
                    checkout: true,
                });
            });
        });
    }

    async handleSubmit(e) {
        gaEvents.eventGeneric(
            "button_click",
            "stripe-chosen",
            this.props.auth.user.id +
                "(GIFT) - choose membership fee - button - choose Stripe"
        );

        this.setState({
            loading: true,
            error: "",
        });

        if (
            this.state.membershipFee === "" ||
            this.state.membershipFee === null
        ) {
            this.setState({
                loading: false,
                error: "Please choose a membership fee option",
            });
            return;
        }

        var membershipFeeStatus = "";
        var pushLocation = "";

        if (this.state.membershipFee === 0) {
            membershipFeeStatus = "completed";
            pushLocation = "/signup-gift/completed";
        } else {
            membershipFeeStatus = "pending";
            pushLocation = "/dashboard/payc-fee";
        }

        this.setState({ membershipFeeStatus: membershipFeeStatus }, () => {
            this.props.auth.updateUser(this.state).then(() => {
                const that = this;
                setTimeout(function () {
                    if (that.state.membershipFee === 0) {
                        that.props.history.push("/signup-gift/completed");
                    } else {
                        that.props.history.push("/signup-gift/payc-fee");
                    }
                }, 2000);
            });
        });
    }

    render() {
        const customStyles = {
            control: (base, state) => ({
                ...base,
                background: "#ffffff",
                color: "#8d95a6",
                height: "58px",
                fontSize: "16px",
                paddingLeft: "0",
                width: "100%",
                marginBottom: "10px",
                flexWrap: "nowrap",
                maxWidth: "500px",
                outline: `${isInPhoneScreen ? "1px solid lightgray" : "none"} `,
                border: "none",
            }),
        };

        if (!this.state.currencySign) {
            return null;
        }
        return (
            <section className="contact-wrapper edit-profile choose-membership-fee">
                <div className="container">
                    <div className="row justify-content-center">
                        <div
                            className={`${
                                isInPhoneScreen ? "col-12" : "col-md-8"
                            } `}
                        >
                            {this.state.checkout ? (
                                <div>
                                    <div>
                                        <Paypal
                                            user={this.props.auth.user}
                                            membershipFee={
                                                this.state.membershipFee
                                            }
                                            currencySign={
                                                this.props.auth.user
                                                    .currencyValue
                                            }
                                            isFromGift={true}
                                            isDev={true}
                                        />
                                    </div>
                                    <div
                                        className="text-center"
                                        style={{ marginTop: "15px" }}
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-danger text-decoration-none"
                                            onClick={() => {
                                                this.setState({
                                                    checkout: false,
                                                });
                                            }}
                                        >
                                            Back
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <div className="contact_form">
                                    <h3 className="title">
                                        Choose membership fee
                                    </h3>

                                    <form
                                        method="POST"
                                        action="/"
                                        name="myForm"
                                        aria-label="Add Profile"
                                        onSubmit={(event) => {
                                            event.preventDefault();
                                            this.handleSubmit();
                                            return false;
                                        }}
                                    >
                                        <input
                                            type="hidden"
                                            name="csrf-token"
                                            value={window.Laravel.csrfToken}
                                        />

                                        <div className="col-12  form-group choose-membership-fee">
                                            <label>Pay as you wish</label>
                                            <p>
                                                In the spirit of inclusion, you
                                                are free to choose whatever you
                                                think Freebird Club is worth for
                                                a full year’s membership. All
                                                payments are securely encrypted
                                                with end-to-end encryption
                                                (E2EE) and you can choose to pay
                                                by credit or debit card using
                                                Stripe, or via Paypal.
                                            </p>
                                            <p>
                                                Drag the slider below to choose
                                                your preferred membership fee.
                                            </p>
                                            <img
                                                src="/images/profile/secured-by-stripe-mini.png"
                                                alt=""
                                                className="img-secured-by-stripe-mini"
                                            />
                                            <hr />
                                        </div>

                                        <div className="btn-toolbar">
                                            <div className="submit-btn">
                                                <Button
                                                    type="submit"
                                                    color="primary"
                                                    icon="fa fa-save"
                                                    loading={this.state.loading}
                                                    classes="multi-button mr-2"
                                                >
                                                    {this.state
                                                        .savedMembershipFee !==
                                                    null
                                                        ? "Pay " +
                                                          decode(
                                                              this.state
                                                                  .currencySign
                                                          ) +
                                                          this.state
                                                              .membershipFee +
                                                          " by credit card"
                                                        : "Pay " +
                                                          decode(
                                                              this.state
                                                                  .currencySign
                                                          ) +
                                                          this.state
                                                              .defaultMembershipFee +
                                                          " by credit card"}
                                                </Button>
                                                <button
                                                    type="button"
                                                    loading={this.state.loading}
                                                    className="btn btn-warning text-decoration-none multi-button mr-2"
                                                    onClick={() => {
                                                        this.handleChoosePaypal();
                                                    }}
                                                >
                                                    {this.state
                                                        .savedMembershipFee !==
                                                    null
                                                        ? "Pay " +
                                                          decode(
                                                              this.state
                                                                  .currencySign
                                                          ) +
                                                          this.state
                                                              .membershipFee +
                                                          " using Paypal"
                                                        : "Pay " +
                                                          decode(
                                                              this.state
                                                                  .currencySign
                                                          ) +
                                                          this.state
                                                              .defaultMembershipFee +
                                                          " using Paypal"}
                                                </button>
                                                <Link
                                                    to="/signup-gift"
                                                    className="btn btn-danger text-decoration-none multi-button"
                                                >
                                                    Back
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="form-error">
                                            <Error error={this.state.error} />
                                        </div>
                                    </form>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default withRouter(withAuth(ChooseMembershipFeeGift));
